import React, { useEffect, useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import SendIcon from "@material-ui/icons/Send";
import { treinoApi, clienteTreinoApi } from "../../../services/Api";
import { SimpleDialog, SimpleFormDialog } from "elentari";
import FullCalendar from "@fullcalendar/react";
import interactionPlugin, { Draggable } from "@fullcalendar/interaction";
import dayGridPlugin from "@fullcalendar/daygrid";
import "./fullcalendar.scss";
import * as R from "ramda";
import TreinoPicker from "./TreinoPicker";
import { getColor, getImage } from "./lib";
import { useClientHaveFcm } from "../../Fcm/hooks";
import Moment from "moment";
import { extendMoment } from "moment-range";

const moment = extendMoment(Moment);

const styles = (theme) => ({
  treinosPickerRoot: {
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: 8,
    padding: theme.spacing.unit * 2,
  },
  treinoItem: {
    borderRadius: 4,
    padding: theme.spacing.unit,
    color: "white",
  },
  gridTreinos: {
    padding: theme.spacing.unit * 2,
    paddingTop: 78,
  },
  gridCalendar: {
    paddingLeft: theme.spacing.unit * 2,
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
  },
  eventFinished: {
    "&:first-line": {
      textDecoration: "line-through",
    },
  },
});

const Calendar = ({
  events,
  classes,
  onEventClick,
  onDropEvent,
  onChageMonth,
  onNewEvent,
  onResize,
}) => (
  <FullCalendar
    events={events}
    editable
    header={{ center: "title", left: "", right: "today prev,next" }}
    locale="pt-br"
    buttonText={{ today: "Hoje" }}
    themeSystem="bootstrap"
    eventDrop={onDropEvent}
    eventResize={onResize}
    eventRender={(info) => {
      const image = getImage(info.event._def.extendedProps.esforco);
      info.el.firstChild.innerHTML = `<div><span>${
        info.el.firstChild.innerText
      }</span> ${
        image
          ? `<img style="margin-left: auto; margin-right:auto; margin-top: 5px; display: block; " src="${image}" height="20%" width="20%" />`
          : ""
      }</div> `;
      return info.el;
    }}
    drop={onNewEvent}
    datesRender={(e) => onChageMonth(e.view.currentStart)}
    eventClick={onEventClick}
    plugins={[dayGridPlugin, interactionPlugin]}
  />
);

const ClienteTreinoGrid = ({
  classes,
  eventDeleteIntention,
  setEventDeleteIntention,
  onDelete,
  dialogOpen,
  setDialogOpen,
  fnEnviarNotificacao,
  disabledTextFcm,
  errorOnSendMessage,
  setErrorOnSendMessage,
  ...props
}) => (
  <Grid container>
    <Grid item xs={9} className={classes.gridCalendar}>
      <Calendar {...props} />
    </Grid>
    <Grid item xs={3} className={classes.gridTreinos}>
      <TreinoPicker />
      <Grid justify="flex-end" container spacing={16}>
        <Grid item classes={{ item: classes.buttonContainer }}>
          <Button
            fullWidth
            type="button"
            color="primary"
            onClick={() => setDialogOpen(true)}
          >
            Notificar cliente
            <SendIcon style={{ marginLeft: 10 }} />
          </Button>
        </Grid>
      </Grid>
    </Grid>
    <SimpleDialog
      open={!!eventDeleteIntention}
      buttonLabel="Cancelar"
      handleClose={() => setEventDeleteIntention(null)}
      primaryAction={onDelete}
      title="Remover evento"
      message={`Deseja remover o evento ${
        eventDeleteIntention && eventDeleteIntention.title
      }?`}
      primaryActionButtonLabel="Remover"
    />
    <SimpleFormDialog
      title="Notificar"
      open={dialogOpen}
      buttonLabel="Cancelar"
      primaryAction={fnEnviarNotificacao}
      primaryActionButtonLabel="Enviar"
      firstFormLabel="Título"
      firstDefaultValue="Treino"
      secondFormLabel="Mensagem"
      secondDefaultValue="Novos treinos estão disponíveis!"
      disabledText={disabledTextFcm}
      handleClose={() => setDialogOpen(false)}
    />
    <SimpleDialog
      title="Atenção"
      message="Ocorreu um erro no envio da mensagem, por favor tente novamente mais tarde."
      open={errorOnSendMessage}
      primaryActionButtonLabel="Ok"
      handleClose={() => setErrorOnSendMessage(null)}
    />
  </Grid>
);

const callbackCopyEvent = (event) => ({
  id: Number(event.event.id),
  title: event.event.title,
  backgroundColor: event.event.backgroundColor,
  borderColor: event.event.borderColor,
  start: moment(event.event.start).format("YYYY-MM-DD"),
  date: moment(event.event.start).format("YYYY-MM-DD"),
  end: moment(event.event.end || event.event.start).format("YYYY-MM-DD"),
});

const ClienteTreino = ({ classes, match }) => {
  const [eventDeleteIntention, setEventDeleteIntention] = useState();
  const [events, setEvents] = useState([]);
  const [currentMonth, setCurrentMonth] = useState();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [errorOnSendMessage, setErrorOnSendMessage] = useState(false);

  const disabledTextFcm = useClientHaveFcm(match.params.id);

  useEffect(() => {
    fetchTreinos(moment());
    new Draggable(document.getElementById("list"), {
      itemSelector: ".item-draggable",
    });
  }, []);

  const fetchTreinos = async (date) => {
    const getEsforco = (esforco) => {
      if (esforco) return `\nEsforço: ${esforco}`;
      return "";
    };

    if (moment(date).month() === currentMonth) {
      return;
    }

    setCurrentMonth(moment(date).month());
    const where = {
      clienteId: match.params.id,
    };

    if (date) {
      where.and = [
        { data: { gt: moment(date).startOf("month").subtract(1) } },
        { data: { lt: moment(date).endOf("month") } },
      ];
    }

    const response = await clienteTreinoApi.getList({ where });
    if (response.ok) {
      const events = await Promise.all(
        response.data.map(async (e) => {
          const { data } = await treinoApi.getOne(e.treinoId);
          return {
            date: moment(e.data).format("YYYY-MM-DD"),
            id: e.id,
            clienteId: e.clienteId,
            treinoId: e.treinoId,
            title: data.nome + getEsforco(e.esforco),
            color: getColor(data, e.esforco),
            esforco: e.esforco,
            concluido: e.concluido,
            className: e.concluido ? classes.eventFinished : "",
          };
        })
      );
      setEvents(events);
    }
  };

  const enviarNotificacao = async (title, body) => {
    const id = match.params.id;
    const response = await clienteTreinoApi.notify(id, { title, body });

    if (!response.ok) setErrorOnSendMessage(true);
  };

  const createEvent = (treinoId) => async (event) => {
    const response = await clienteTreinoApi.create({
      concluido: false,
      treinoId,
      clienteId: +match.params.id,
      data: moment(event.date).format(),
    });

    if (response.ok) {
      return {
        ...event,
        treinoId,
        id: response.data.id,
      };
    }
    return {
      error: true,
      data: response.data,
    };
  };

  const handleNewEvent = async (event) => {
    const newEvent = JSON.parse(event.draggedEl.dataset.event);
    const result = await createEvent(newEvent.treinoId)({
      date: event.dateStr,
      ...newEvent,
    });
    if (result.error) {
      alert("Ocorreu um erro ao criar evento");
      return;
    }
    setEvents(events.concat(result));
  };

  const handleEventResize = async (event) => {
    event.revert();
    const eventCopy = callbackCopyEvent(event);
    const originalEvent = R.find(R.propEq("id", +eventCopy.id), events);
    const end = moment(eventCopy.end).subtract(1, "day");
    const start = moment(eventCopy.start).add(1, "day");
    const newEvents = Array.from(moment.range(start, end).by("days")).map(
      (day, index) => ({
        ...eventCopy,
        date: day.format("YYYY-MM-DD"),
        start: undefined,
        end: undefined,
        id: undefined,
      })
    );
    delete eventCopy.start;
    delete eventCopy.end;
    const promises = newEvents.map(createEvent(originalEvent.treinoId));
    const results = await Promise.all(promises);
    setEvents(events.concat(results.filter((r) => !r.error)));
    results.forEach((result) => {
      if (result.error) {
        alert("Erro ao criar eventos de resize");
      }
    });
  };

  const handleEventDrop = async (event) => {
    const newEvent = callbackCopyEvent(event);
    const originalEvent = R.find(R.propEq("id", +newEvent.id), events);
    if (originalEvent.concluido) {
      return event.revert();
    }
    const response = await clienteTreinoApi.update(newEvent.id, {
      data: moment(newEvent.date).format(),
    });
    if (response.ok) {
      const newEvents = events.filter((e) => e.id !== newEvent.id);
      newEvents.push({
        ...originalEvent,
        date: newEvent.date,
      });
      setEvents(newEvents);
      return;
    }
    alert("Erro ao alterar evento");
  };

  const handleDelete = async () => {
    const response = await clienteTreinoApi.deleteF(eventDeleteIntention.id);
    if (response.ok) {
      setEvents(events.filter((e) => e.id !== eventDeleteIntention.id));
    }
    setEventDeleteIntention(null);
  };

  return (
    <ClienteTreinoGrid
      classes={classes}
      events={events}
      onChageMonth={fetchTreinos}
      onNewEvent={handleNewEvent}
      onDropEvent={handleEventDrop}
      onResize={handleEventResize}
      onEventClick={(event) =>
        setEventDeleteIntention(callbackCopyEvent(event))
      }
      onDelete={handleDelete}
      setEventDeleteIntention={setEventDeleteIntention}
      eventDeleteIntention={eventDeleteIntention}
      dialogOpen={dialogOpen}
      setDialogOpen={setDialogOpen}
      fnEnviarNotificacao={enviarNotificacao}
      disabledTextFcm={disabledTextFcm}
      errorOnSendMessage={errorOnSendMessage}
      setErrorOnSendMessage={setErrorOnSendMessage}
    />
  );
};

export default withStyles(styles)(ClienteTreino);
